module.exports = __webpack_public_path__ + "static/media/cesta.7dddd74a.png";